import React, { ReactNode, useRef } from 'react'
import { IssueEntity, IssueType } from 'types/IssueEntity'
import { WarrantEntity } from 'types/WarrantEntity'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { EventWithPosition, useEvents } from './useEvents'

export type EventItem = {
    x: Date
    y: number
    label: ReactNode
    backgroundColor: string
    type: 'issue' | 'warrant' | 'cluster'
    id: string
    category: IssueType | 'warrant'
}

export const ChartCompanyEvents = ({
    onSelect,
    issues,
    warrants,
}: {
    onSelect: (type: 'issue' | 'warrant', issueId: string) => void
    issues: IssueEntity[] | null
    warrants: WarrantEntity[] | null
}) => {
    const events = useEvents(issues, warrants)

    return events.map((event) => (
        <EventLabel
            key={event.id}
            {...event}
            onClick={(type, id) => {
                if (type === 'issue' || type === 'warrant') return onSelect(type, id)
            }}
        />
    ))
}

const EventLabel = ({
    backgroundColor,
    onClick,
    type,
    id,
    label,
    position,
}: {
    backgroundColor: string
    onClick: (type: EventItem['type'], id: string) => void
    position: EventWithPosition['position']
    type: EventItem['type']
    id: string | null
    label: ReactNode
}) => {
    const buttonRef = useRef<HTMLButtonElement>(null)
    const { button: buttonPosition, pin: pinPos, zIndex } = position

    return (
        <>
            <Button
                disabled={!id}
                onClick={() => (!id ? undefined : onClick(type, id))}
                ref={buttonRef}
                sx={{
                    minWidth: 'fit-content',
                    padding: 0,
                    position: 'absolute',
                    left: buttonPosition.left,
                    top: buttonPosition.top,
                    px: 1,
                    width: buttonPosition.width,
                    zIndex,
                    '.MuiTypography-root': {
                        width: '100%',
                    },
                    '.MuiStack-root': {
                        display: 'block',
                    },
                    '.MuiChip-root': {
                        display: 'flex',
                        borderBottomLeftRadius: buttonPosition.left < 0 ? 0 : undefined,
                    },
                    '.MuiChip-label': {
                        paddingX: 0,
                    },
                }}
            >
                <Typography variant='caption'>{label}</Typography>
            </Button>
            <div
                style={{
                    position: 'absolute',
                    pointerEvents: 'none',
                    left: pinPos.left,
                    height: pinPos.height,
                    top: pinPos.top,
                    width: pinPos.width,
                    backgroundColor,
                    zIndex,
                }}
            />
        </>
    )
}
